import React, { useState } from 'react';
import { testApi, storeApi } from '../services/api';
import { Button, Typography, Box, Paper, CircularProgress, Alert } from '@mui/material';

const ApiTest: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [testResult, setTestResult] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [storeInfo, setStoreInfo] = useState<any>(null);

  const handleTestConnection = async () => {
    setLoading(true);
    setError(null);
    setTestResult(null);
    try {
      const result = await testApi.testConnection();
      setTestResult(JSON.stringify(result, null, 2));
    } catch (err: any) {
      setError(`API 연결 오류: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleGetStoreInfo = async () => {
    setLoading(true);
    setError(null);
    setStoreInfo(null);
    try {
      const response = await storeApi.getStoreInfo(1);
      setStoreInfo(response.data);
    } catch (err: any) {
      setError(`매장 정보 조회 오류: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 600, margin: '0 auto', padding: 3 }}>
      <Typography variant="h5" gutterBottom>
        백엔드 API 연결 테스트
      </Typography>
      
      <Box sx={{ display: 'flex', gap: 2, marginBottom: 2 }}>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleTestConnection}
          disabled={loading}
        >
          API 연결 테스트
        </Button>
        
        <Button 
          variant="contained" 
          color="secondary" 
          onClick={handleGetStoreInfo}
          disabled={loading}
        >
          매장 정보 조회
        </Button>
      </Box>
      
      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', marginY: 2 }}>
          <CircularProgress />
        </Box>
      )}
      
      {error && (
        <Alert severity="info" sx={{ marginY: 2 }}>
          {error}
        </Alert>
      )}
      
      {testResult && (
        <Paper sx={{ padding: 2, marginY: 2, backgroundColor: '#f5f5f5' }}>
          <Typography variant="subtitle1" gutterBottom>
            API 테스트 결과:
          </Typography>
          <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
            {testResult}
          </pre>
        </Paper>
      )}
      
      {storeInfo && (
        <Paper sx={{ padding: 2, marginY: 2, backgroundColor: '#f5f5f5' }}>
          <Typography variant="subtitle1" gutterBottom>
            매장 정보:
          </Typography>
          <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
            {JSON.stringify(storeInfo, null, 2)}
          </pre>
        </Paper>
      )}
    </Box>
  );
};

export default ApiTest; 